import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import pageWrapper from '../../containers/MainPage';
import Button from '../../common/Button';

import TextInput from '../../common/form/TextInput';
import './NoSearchTermPage.css';

class NoSearchTermPage extends React.PureComponent {
  render() {
    return (
      <div className="columns is-centered">
        <div
          className="column is-half notification is-info has-text-centered"
          style={{ marginTop: '20%' }}
        >
          <h5 className="title is-5">Please enter a value to search for:</h5>
          <div className="noTerm-search is-half">
            <Formik
              onSubmit={(values) => {
                const value = !values.searchTerm ? '' : values.searchTerm;
                this.props.history.push(`/collections/search/${value}`);
              }}
              render={({
                handleSubmit,
              }) => (
                <Form>
                  <div className="noTerm-search">
                    <Field
                      name="searchTerm"
                      placeholder=""
                      type="serchTerm"
                      required
                      autoComplete=""
                      component={TextInput}
                    />
                    <Button
                      className="button is-link"
                      type="submit"
                      label={
                        <FontAwesomeIcon icon={faSearch} className="icon" fixedWidth fixedHeight />
                      }
                      handler={handleSubmit}
                    />
                  </div>
                </Form>
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

NoSearchTermPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(pageWrapper(NoSearchTermPage, 'Search'));



// WEBPACK FOOTER //
// ./src/components/pages/collections/NoSearchTermPage.jsx